<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader style="max-width: 555px" v-bind="attrs" type="card" v-if="isLoading">
			</v-skeleton-loader>
			<div v-else>
				<div class="action-links-page" v-if="actionLinks && actionLinks.length > 0">
					<div
						class="action-links-page__link-wrapper"
						v-for="link in actionLinks"
						:key="link.id"
					>
						<div
							@click="toggleToLink(link.link_url)"
							class="action-links-page__link-wrapper__text-container cursor-pointer"
						>
							<a class="action-links-page__link-wrapper__link">
								{{ link.link_title }}
							</a>
							<span
								v-if="link.link_description"
								class="action-links-page__link-wrapper__description"
							>
								{{ link.link_description }}
							</span>
						</div>
						<Icon type="chevron_right" color="#9B9B9B" :size="24" />
					</div>
				</div>
			</div>
			<v-dialog
				v-model="mobileLink"
				class="exhibitor-page__modal"
				max-width="588px"
				width="100%"
				persistent
			>
				<v-card class="exhibitor-page__modal">
					<div class="exhibitor-page__modal__title">
						This screen is not available in the Web App, but you can access it through
						the mobile app
					</div>
					<button
						type="button"
						@click="toggleCloseMobileLink"
						class="exhibitor-page__modal__btn"
					>
						OK
					</button>
				</v-card>
			</v-dialog>
			<div v-if="!isLoading && actionLinks.length === 0" class="mt-5 align-center">
				<NewsFeedEmpty
					title="Action Links is empty at the moment."
					description="Check back later."
				/>
			</div>
			<div class="my-9" v-if="!isLoading">
				<Pagination
					:page="filters.page"
					:pageCount="+pageCount"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</v-card-text>
	</div>
</template>
<script>
import Filter from '@/mixins/Filter'
import Block from '@/mixins/Block'
import Pagination from '@/components/Pagination.vue'
import { mapActions, mapGetters } from 'vuex'
import PageBlocked from '@/components/PageBlocked.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
export default {
	name: 'ActionLinksPage',
	mixins: [Filter, Block],
	components: {
		PageBlocked,
		Pagination,
		NewsFeedEmpty,
	},
	data() {
		return {
			mobileLink: false,
			pageBlockedName: 'events',
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
		}
	},
	computed: {
		...mapGetters('event', ['actionLinks', 'actionLinksMeta', 'isLoading']),
		...mapGetters('settings', ['appCore']),
		...mapGetters('auth', ['mapRegisterToken']),
		pageCount() {
			return this.actionFilesMeta?.pageCount || 1
		},
		pageTitle() {
			return this.$route.query.title || null
		},
	},
	methods: {
		...mapActions('event', ['getActionLinks']),
		...mapActions('app', ['setPageTitle']),
		...mapActions('auth', ['getMapRegisterToken']),
		transformDeepLink(link) {
			const match = link.match(/:\/\/(.*)/)
			return match ? `${window.location.origin}/webapp/${match[1]}` : link
		},
		isMapUrlValid(url) {
			try {
				const arr = JSON.parse(this.appCore.parsing_url)
				const link = new URL(url)
				return arr.some((allowed) => link.origin === allowed)
			} catch (e) {
				console.error(e)
				return false
			}
		},
		toggleCloseMobileLink() {
			this.mobileLink = false
		},
		async toggleToLink(link) {
			if (!link.startsWith('https')) {
				const restrictedLinks = [
					'live-events',
					'event-manager',
					'higher-logic',
					'gamification',
				]
				const lowerCaseLink = link.toLowerCase()
				const isRestricted = restrictedLinks.some((restricted) =>
					lowerCaseLink.includes(restricted)
				)
				if (isRestricted) {
					this.mobileLink = true
					return
				}
				const deepLink = this.transformDeepLink(link)
				window.open(deepLink, '_self')
			} else if (this.isMapUrlValid(link)) {
				try {
					await this.getMapRegisterToken()
					const token = this.mapRegisterToken
					if (!token) return
					let url = link
					url += url.includes('?') ? `&token=${token}` : `?code=${token}`
					window.open(url, '_self')
				} catch (e) {
					console.error(e)
				}
			} else {
				window.open(link, '_self')
			}
		},
	},
	mounted() {
		this.setPageTitle(this.pageTitle)
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		if (
			this.$route.params.eventId !== undefined &&
			this.$route.params.actionId !== undefined &&
			(!this.isBlocked || this.isBlocked === null)
		) {
			this.getActionLinks(this.requestQuery)
		}
	},
}
</script>

<style lang="scss">
.action-links-page {
	user-select: unset;
	display: flex;
	flex-direction: column;
	gap: 8px;
	font-family: 'Inter', sans-serif;
	&__link-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		background-color: #ffffff;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
		padding: 12px;
		&__text-container {
			display: flex;
			flex-direction: column;
			gap: 8px;
		}

		&__description {
			color: #9b9b9b;
			font-weight: 400;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
		}

		&__link {
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--link);
			text-decoration: unset;
		}
	}
}
</style>
